import { render, staticRenderFns } from "./PapercleanConfigurazioneDizionariViewComponent.vue?vue&type=template&id=2b2e482d&scoped=true"
import script from "./PapercleanConfigurazioneDizionariViewComponent.vue?vue&type=script&lang=js"
export * from "./PapercleanConfigurazioneDizionariViewComponent.vue?vue&type=script&lang=js"
import style0 from "./PapercleanConfigurazioneDizionariViewComponent.vue?vue&type=style&index=0&id=2b2e482d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e482d",
  null
  
)

export default component.exports